// src/components/Popup/Popup.js
import React, { useEffect, useState } from 'react';
import axios from '../api/axios'; // Assuming correct path to axios instance
import './Popup.css';

const Popup = () => {
  const [image, setImage] = useState(null);
  const [show, setShow] = useState(false);
  
  const BASE_URL = 'https://blog.dietchapter.hosting.acm.org/'; // Base URL for uploaded files

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('popupShown');
    
    // Only fetch and show if the user has NOT seen the popup yet
    if (!hasSeenPopup) {
      // The backend route for fetching the single popup image
      axios.get('/popup') 
        .then((res) => {
          // The backend returns the latest popup object or null
          const popupData = res.data; 
          
          if (popupData && popupData.imagePath) {
            // Construct the full image URL
            setImage(`${BASE_URL}/${popupData.imagePath.replace(/\\/g, '/')}`);
            setShow(true);
            
            // Set localStorage flag so the popup doesn't appear on subsequent page loads
            localStorage.setItem('popupShown', 'true'); 
          }
        })
        .catch((err) => console.error('Popup fetch error:', err));
    }
    
    // Cleanup function: If the component unmounts while shown, we might still want to track seen status
    return () => {
        // Optional: If you prefer the popup to be shown *only* on the first session, 
        // you might use sessionStorage instead of localStorage.
    };
  }, []);

  if (!show || !image) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <img src={image} alt="Popup Announcement" />
        <button className="popup-close" onClick={() => setShow(false)}>✖</button>
      </div>
    </div>
  );
};

export default Popup;